import { render, staticRenderFns } from "./HomeTracking.vue?vue&type=template&id=3136521c&scoped=true&"
import script from "./HomeTracking.vue?vue&type=script&lang=js&"
export * from "./HomeTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136521c",
  null
  
)

export default component.exports